import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  emptyScreen: {
    height: "calc(100vh - 360px)",
  },
}));

export default useStyles;
